import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Products from "./components/Products";
import SEOContent from "./components/SEOContent";
import ArticlesSection from "./components/ArticlesSection";
import Trust from "./components/Trust";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <Products />
        <SEOContent />
        <ArticlesSection />
        <Trust />
        <FAQ />
        <CTA />
        {/* Home Breadcrumb & WebPage Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cssbuy.gay/" }
              ]
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}